/** @file Placeholder names already used for a slot: its setup attachment and every skin's entries. */
import type { Doc, Id } from '@pose2d/format/types';

/** Distinct placeholders of `slot` across the setup attachment and all skins, sorted. */
export function slotPlaceholders(doc: Doc, slot: Id): string[] {
  const found = new Set<string>();
  const setup = doc.slots[slot]?.setup.attachment;
  if (setup !== undefined && setup !== null) found.add(setup);
  for (const skin of Object.values(doc.skins)) for (const e of skin.entries) if (e.slot === slot) found.add(e.placeholder);
  return [...found].sort();
}
